<template lang="pug">
	.app-core--file-uploader
		DxButton(:text="text", @click="onUIButtonClick", :icon="icon", :type="type", v-if="!isUIHidden", :disabled="!!isLoading || disabled")
		Popup(:popupVisible.sync="visible", v-bind="popupConfig", @hiding="v => $emit('popup', v)", :closeOnOutsideClick="closeOnOutsideClick")
			.app-core--file-uploader(:style="{ '--dropZoneHeight': `${dropZoneHeight || 400}px` }")
				.box-highlighter(v-if="!uploadSelectorHidden", :class="{ 'is-dragover': isDragover, 'has-files': !!files.length }")
				form.file-uploader-box.flex-col.center.align-center(ref="form", method="post" action="#" enctype="multipart/form-data")
					.box-input.flex-col.space
						slot(name="top-content")
						template(v-if="!uploadSelectorHidden")
							input.box-file(ref="inputFiles", type="file", :id="inputId", :multiple="multiple !== false", @change="onInputChange", :accept="(accept || []).join(',')")
							label.upload-text.flex-row.space.align-center(:for="inputId")
								DxButton(icon="fas fa-search", :text="$tCaption('Select file')", @click="onSelectFileClick", :disabled="disabled")
								span.box-dragndrop {{dropTextValue}}
							.flex-col.space
								.selected-file.flex-row.space.align-center(v-for="(file, idx) in files")
									DxButton(icon="remove", @click="removeFile(idx)", :disabled="disabled")
									span {{file.name}} ({{getFileSizeInMb(file.size)}}MB)
								.error-colored.upper(v-if="errorMessage") {{ errorMessage }}
						slot
						slot(name="bottom-content")
			template(slot="actions-right")
				slot(name="actions-right")
				DxButton(
					:text="uploadText || $tCaption('Upload', '@actions')",
					@click="upload",
					icon="fas fa-check",
					type="default",
					:disabled="(uploadButtonActive != null && !uploadButtonActive) || (uploadButtonActive == null && (!files.length || !!isLoading || errorMessage || disabled))"
				)
				DxButton(
					:text="$tCaption('Cancel', '@actions')",
					@click="close",
					:disabled="disabled",
					icon="fas fa-times"
				)
</template>

<script>
	import $ from 'jquery';
	import Popup from './Popup.vue';
	import { DxFileUploader } from 'devextreme-vue/file-uploader';
	import DxButton from 'devextreme-vue/button';

	export default {
		name: 'app-core--file-uploader',
		components: {
			Popup, DxButton, DxFileUploader
		},
		props: [
			'text', 'icon', 'type', 'accept', 'multiple', 'popupConfig', 'dropText', 'isUIHidden',
			'preventClose', 'isLoading', 'closeOnOutsideClick', 'dropZoneHeight', 'uploadText',
			'errorMessage', 'disabled', 'uploadButtonActive', 'holdFiles', 'uploadSelectorHidden', 'initFiles'
		],
		data() {
			return {
				visible: false,
				files: [],
				inputId: `file_${this.$Data.uuid()}`,
				isDragover: false
			};
		},
		watch: {
			visible(v) {
				if (v && !this.holdFiles) {
					this.files = [];
				}
				this.$emit('popup', v);
			},
			files() {
				this.$emit('files-changed', this.files);
			}
		},
		computed: {
			dropTextValue() {
				let text = this.dropText || this.$tCaption('or drag it here');
				return `${`${text[0]}`.toLowerCase()}${`${text}`.slice(1, 9999)}`;
			}
		},
		mounted() {
			if (__DEBUG__)
				window.fileUploader = this;
		},
		methods: {
			onUIButtonClick() {
				this.$emit('ui-button-click');
				this.showPopup();
			},
			onSelectFileClick(e) {
				if (e?.event) {
					e.event.stopPropagation();
					e.event.preventDefault();
					$(this.$refs.inputFiles).trigger('click');
				}
			},
			getFileSizeInMb(bytesLength) {
				return 	Math.round(bytesLength /1024 /1024 * 10)/10;
			},
			upload() {
				this.$emit('upload', this.files);
				if (!this.preventClose)
					this.close();
			},
			close() {
				this.visible = false;
				if (!this.holdFiles) {
					this.files = [];
				}
			},
			showPopup() {
				this.visible = false;
				setImmediate(() => {
					if (this._isDestroyed) return;

					if (!this.holdFiles || !this.files?.length) {
						this.files = [...(this.initFiles || [])];
					}

					this.visible = true;
					this.$emit('popup', this.visible);
					setImmediate(() => {
						this.initForm();
					});
				});
			},
			initForm() {
				let form = $(this.$refs.form);
				form.on('drag dragstart dragend dragover dragenter dragleave drop', (e) => {
					e.preventDefault();
					e.stopPropagation();
				})
				.on('dragover dragenter', () => {
					this.isDragover = true;
				})
				.on('dragleave dragend drop', () => {
					this.isDragover = false;
				})
				.on('drop', (e) => this.processFilesList(e?.originalEvent?.dataTransfer?.files));
			},
			onInputChange(e) {
				if (__DEBUG__)
					console.debug('Input select', { e });
				this.processFilesList(this.$refs.inputFiles?.files);
			},
			processFilesList(list) {
				this.files = [];
				list?.forEach(f =>{
					if (this.files.length && !this.multiple) return;
					this.files.push(f);
				});
				this.$emit('file-selected', this.files);
			},
			removeFile(idx) {
				if (this.$refs.inputFiles) {
					this.$refs.inputFiles.value = null;
				}
				this.files.splice(idx, 1);
				this.$emit('remove-files', this.files);
				this.$emit('file-selected', []);
			},
		}
	};
</script>

<style lang='scss'>
	.app-core--file-uploader {
		@import "main/themes/generated/variables.base.scss";

		.file-uploader-box {
			min-height: var(--dropZoneHeight);

			.box-input {
				padding: 10px;
			}

			.box-dragndrop {
				display: inline;
			}

			&.is-dragover {
				background-color: rgba(0,0,0,0.1);
				outline-offset: -20px;
			}

			.box-file {
				width: 0.1px;
				height: 0.1px;
				opacity: 0;
				overflow: hidden;
				position: absolute;
				z-index: -1;
			}

			.upload-text {
				font-size: 20px;
				font-weight: 100;
			}

			.file-choose {
				cursor: pointer;

				&:hover {
					color: $base-accent;
				}
			}
		}

		.box-highlighter {
			transition: 0.15s;
			border-radius: 4px;
			position: absolute;
			width: 100%;
			height: var(--dropZoneHeight);
			border: 4px dashed rgba(0,0,0,0.1);
			pointer-events: none;
			transition: 0.3s;

			&.is-dragover {
				background-color: rgba(0,0,0,0.05);
				border: 4px dashed rgba(0,0,0,0.2);
			}

			&.has-files:not(.is-dragover) {
				border: 4px dashed rgba(0,0,0,0);
			}
		}
	}
</style>
